import { render, staticRenderFns } from "./GalleryBig4.vue?vue&type=template&id=611b7e2a&scoped=true&"
import script from "./GalleryBig4.vue?vue&type=script&lang=js&"
export * from "./GalleryBig4.vue?vue&type=script&lang=js&"
import style0 from "./GalleryBig4.vue?vue&type=style&index=0&id=611b7e2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611b7e2a",
  null
  
)

export default component.exports